var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('van-button',{attrs:{"type":"info","loading":_vm.showloading,"loading-type":"spinner","icon":"replay"},on:{"click":function($event){return _vm.TestClick()}}},[_vm._v("信息按钮")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }